const MENU = {
    PREVIEW_SLIDE: 'PREVIEW_SLIDE',
    STOP_PREVIEW: 'STOP_PREVIEW',
    SWITCH_EDIT_TEXT_PANEL: 'SWITCH_EDIT_TEXT_PANEL',
    SHIFT_PRESS: 'SHIFT_PRESS',
    CTRL_PRESS: 'CTRL_PRESS',
    ADD_SELECTED_CAPTION: 'ADD_SELECTED_CAPTION',
    CHOOSE_ANOTHER_ONE_CAPTION: 'CHOOSE_ANOTHER_ONE_CAPTION',
    UNSELECT_CAPTION: 'UNSELECT_CAPTION',
    ADD_ALL_CAPTIONS: 'ADD_ALL_CAPTIONS',
    ADD_SOME_CAPTIONS: 'ADD_SOME_CAPTIONS',
    CLEAR_SELECTED_CAPTION: 'CLEAR_SELECTED_CAPTION',
    COPY_CAPTIONS: 'COPY_CAPTIONS',
    CHANGE_GRID: 'CHANGE_GRID',
    INIT_SAVED_RULERS: 'INIT_SAVED_RULERS',
    CHANGE_RULERS: 'CHANGE_RULERS',
    ADD_RULER: 'ADD_RULER',
    DELETE_RULER: 'DELETE_RULER',
    CHANGE_RULER_POSITION: 'CHANGE_RULER_POSITION',
    CHANGE_VIEW_TYPE: 'CHANGE_VIEW_TYPE',
    CHANGE_EDITING_CAPTION_INDEX: 'CHANGE_EDITING_CAPTION_INDEX',
    OPEN_FONT_PICKER: 'OPEN_FONT_PICKER',
    OPEN_SHADOW_PICKER: 'OPEN_SHADOW_PICKER',
    CHANGE_FONT_PICKER_POSITION: 'CHANGE_FONT_PICKER_POSITION',
    CHANGE_SHADOW_PICKER_POSITION: 'CHANGE_SHADOW_PICKER_POSITION',
    CHANGE_BOX_FIGURE_IS_EDIT: 'CHANGE_BOX_FIGURE_IS_EDIT',
    CHANGE_PIPETT: 'CHANGE_PIPETT',
    CHANGE_MOBILE_VIEW_SCALE: 'CHANGE_MOBILE_VIEW_SCALE',
    UPDATE_WORKSPACE_RANDOM: 'UPDATE_WORKSPACE_RANDOM',
    SET_UNIC_CLASSNAME: 'SET_UNIC_CLASSNAME',
    SAVE_TEMP_STYLE: 'SAVE_TEMP_STYLE',
    TOGGLE_IMAGE_CROP: 'TOGGLE_IMAGE_CROP',
    VIDEO_TUTORIAL_ACTIVE: 'VIDEO_TUTORIAL_ACTIVE',
    DROPDOWN_IS_OPEN: 'DROPDOWN_IS_OPEN',
    TOGGLE_ICON_MODAL: 'TOGGLE_ICON_MODAL',
    TOGGLE_SVG_MODAL: 'TOGGLE_SVG_MODAL',
    IMAGE_CAPTION_CROP: 'IMAGE_CAPTION_CROP',
}

export {MENU}